import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _ from 'lodash';
import common from '../_common/selectors';
import StyleSelectors from '../Styles/selectors';
import { createSelector } from 'reselect';
import { createSelector as createRecomputeSelector, createObserver as createRecomputeObserver } from '@jvitela/recompute';

var getSubstate = function getSubstate(state) {
  return state.selections;
};

var getActive = common.getActive(getSubstate);
var getActiveKey = common.getActiveKey(getSubstate);
var getAllAsObject = common.getAllAsObject(getSubstate);
var getAll = common.getAll(getSubstate);
var getAllAsObjectWithStyles = createSelector([getAllAsObject, StyleSelectors.getAllAsObject], function (selections, allStyles) {
  if (selections) {
    if (allStyles) {
      var selectionsWithStyles = {};

      _.forIn(selections, function (selection, key) {
        var _selection$data;

        var styleKey = (_selection$data = selection.data) === null || _selection$data === void 0 ? void 0 : _selection$data.styleKey;

        if (styleKey && allStyles[styleKey]) {
          var _allStyles$styleKey$d, _allStyles$styleKey$d2, _allStyles$styleKey$d3, _allStyles$styleKey$d4;

          var selectionStyle = (_allStyles$styleKey$d = allStyles[styleKey].data) === null || _allStyles$styleKey$d === void 0 ? void 0 : (_allStyles$styleKey$d2 = _allStyles$styleKey$d.definition) === null || _allStyles$styleKey$d2 === void 0 ? void 0 : (_allStyles$styleKey$d3 = _allStyles$styleKey$d2.rules) === null || _allStyles$styleKey$d3 === void 0 ? void 0 : (_allStyles$styleKey$d4 = _allStyles$styleKey$d3[0].styles) === null || _allStyles$styleKey$d4 === void 0 ? void 0 : _allStyles$styleKey$d4[0]; // TODO get first style of first rule for now

          if (selectionStyle) {
            selectionsWithStyles[key] = _objectSpread(_objectSpread({}, selection), {}, {
              data: _objectSpread(_objectSpread({}, selection.data), {}, {
                style: selectionStyle
              })
            });
          } else {
            selectionsWithStyles[key] = selection;
          }
        } else {
          selectionsWithStyles[key] = selection;
        }
      });

      return selectionsWithStyles;
    } else {
      return selections;
    }
  } else {
    return null;
  }
});
var getByKeyObserver = createRecomputeObserver(function (state, key) {
  return state.selections.byKey[key];
});
var prepareSelectionByLayerStateSelected = createRecomputeSelector(function (layerStateSelected) {
  var populatedSelections = {};

  _.forIn(layerStateSelected, function (value, key) {
    var selection = getByKeyObserver(key);
    var selectionData = selection === null || selection === void 0 ? void 0 : selection.data;

    if (selectionData) {
      var style = selectionData.style;
      var hoveredStyle = selectionData.hoveredStyle || style;
      var color = selectionData.color;
      var hoveredColor = selectionData.hoveredColor || color;

      if (selectionData.featureKeysFilter) {
        populatedSelections[key] = {
          keys: selectionData.featureKeysFilter.keys
        };

        if (style) {
          populatedSelections[key].style = style;
          populatedSelections[key].hoveredStyle = hoveredStyle;
        } else {
          populatedSelections[key].style = {
            outlineColor: color,
            outlineWidth: 2
          };
          populatedSelections[key].hoveredStyle = {
            outlineColor: hoveredColor,
            outlineWidth: 2
          };
        }
      } //TODO other selection types

    }
  });

  return populatedSelections;
});
export default {
  getActiveKey: getActiveKey,
  getActive: getActive,
  getAll: getAll,
  getAllAsObject: getAllAsObject,
  getAllAsObjectWithStyles: getAllAsObjectWithStyles,
  prepareSelectionByLayerStateSelected: prepareSelectionByLayerStateSelected
};